"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "store", {
  enumerable: true,
  get: function get() {
    return _store.store;
  }
});
Object.defineProperty(exports, "RootState", {
  enumerable: true,
  get: function get() {
    return _store.RootState;
  }
});
Object.defineProperty(exports, "useAppDispatch", {
  enumerable: true,
  get: function get() {
    return _store.useAppDispatch;
  }
});
Object.defineProperty(exports, "useAppSelector", {
  enumerable: true,
  get: function get() {
    return _store.useAppSelector;
  }
});
exports.languageActions = exports.userActions = exports.previewActions = exports.mediaActions = exports.termActions = exports.postActions = exports.siteActions = exports.authActions = exports.uiActions = exports.cmsActions = void 0;

var _store = require("./store");

var _cmsSlice = require("./slices/cmsSlice");

var _uiSlice = require("./slices/uiSlice");

var authActions = _interopRequireWildcard(require("./actions/authActions"));

exports.authActions = authActions;

var siteActions = _interopRequireWildcard(require("./actions/siteActions"));

exports.siteActions = siteActions;

var postActions = _interopRequireWildcard(require("./actions/postActions"));

exports.postActions = postActions;

var termActions = _interopRequireWildcard(require("./actions/termActions"));

exports.termActions = termActions;

var mediaActions = _interopRequireWildcard(require("./actions/mediaActions"));

exports.mediaActions = mediaActions;

var previewActions = _interopRequireWildcard(require("./actions/previewActions"));

exports.previewActions = previewActions;

var userActions = _interopRequireWildcard(require("./actions/userActions"));

exports.userActions = userActions;

var languageActions = _interopRequireWildcard(require("./actions/languageActions"));

exports.languageActions = languageActions;
var cmsActions = {
  setConfig: _cmsSlice.setConfig,
  setDeploymentImage: _cmsSlice.setDeploymentImage,
  setActiveLanguage: _cmsSlice.setActiveLanguage,
  addEditorSite: _cmsSlice.addEditorSite,
  updateEditorSite: _cmsSlice.updateEditorSite,
  addEditorPost: _cmsSlice.addEditorPost,
  updateEditorPost: _cmsSlice.updateEditorPost,
  clearEditor: _cmsSlice.clearEditor
};
exports.cmsActions = cmsActions;
var uiActions = {
  showDialog: _uiSlice.showDialog,
  hideDialog: _uiSlice.hideDialog,
  updateEditorSettings: _uiSlice.updateEditorSettings
};
exports.uiActions = uiActions;